// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const background = "RedemptionPage__background__UcYJG";
export const bold = "700";
export const content = "RedemptionPage__content__gljzV";
export const footer = "RedemptionPage__footer__0HSnm";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const page = "RedemptionPage__page__l4K8n";
export const progressBar = "RedemptionPage__progressBar__y-+Is";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const subtitle = "RedemptionPage__subtitle__Elj1r font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const textCenter = "RedemptionPage__textCenter__u0KDH";